<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form ref="ff" size="small" :inline="true" :model="queryParams">
        <el-form-item>
          <metaPicker
            type="demand-type"
            placeholder="商机类别"
            :value.sync="queryParams.type"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <metaPicker
            type="demand-step-client"
            placeholder="客户进度"
            :value.sync="queryParams.step"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="queryParams.keyWord"
            clearable
            placeholder="客户/需求"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch()">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--表格-->
    <el-table ref="tb" :data="datalist.Items" height="100%" size="mini" border>
      <el-table-column label="线索类别" min-width="100" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ $utils.meta.format("demand-type", row.Type) }}
        </template>
      </el-table-column>
      <el-table-column prop="Client" label="客户单位" min-width="200" fixed>
        <template slot-scope="{ row }">
          <el-popover placement="top" trigger="hover">
            <p class="text-bold">{{ row.Client }}</p>
            <p>联系地址：{{ row.Address }}</p>
            <p>联系方式：{{ row.Linkman }} {{ row.Linktel }}</p>
            <el-link
              slot="reference"
              class="text-cut"
              type="primary"
              @click="$router.push({ path: `detail`, query: { id: row.Id } })"
            >
              <el-tag size="mini" v-if="!row.CustomerId"> 新 </el-tag>
              {{ row.Client }}
            </el-link>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="Explain" label="客户需求" min-width="200">
        <template slot-scope="{ row }">
          <span class="text-cut">{{ row.Explain }}</span>
        </template>
      </el-table-column>
      <el-table-column label="预计销售金额" min-width="120">
        <span
          class="text-price"
          slot-scope="{ row }"
          v-if="row.ProAmount > 0"
          >{{ row.ProAmount }}</span
        >
      </el-table-column>
      <el-table-column label="预计签单日期" min-width="120">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row?.ProDealDate) }}
        </template>
      </el-table-column>
      <el-table-column label="线索负责人" min-width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ row.Dept }} {{ row.User }}
        </template>
      </el-table-column>
      <el-table-column label="上次跟进情况" min-width="140">
        <template slot-scope="{ row }">
          <el-link @click.native="onSchedule(row.Last.Id)">
            {{
              $utils.common.parseTime(
                row?.Last?.ExecTime,
                "{y}-{m}-{d} {h}:{i}"
              )
            }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="下次跟进计划" min-width="140">
        <template slot-scope="{ row }">
          <el-link
            @click.native="
              onProgress({
                Id: row.Next.Id,
                Type: row.Next.Type,
                State: 9,
                Target: row.Id,
                Client: row.Next.Client,
                Address: row.Next.Address,
                Linkman: row.Next.Linkman,
                Linktel: row.Next.Linktel,
                Request: row.Next.Request,
                Step_Client: row.Step_Client,
                Step_Corp: row.Step_Corp,
              })
            "
          >
            {{
              $utils.common.parseTime(
                row?.Next?.PlanTime,
                "{y}-{m}-{d} {h}:{i}"
              )
            }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="客户进度" width="200">
        <template slot-scope="{ row }">
          <el-dropdown>
            <el-link type="primary" style="font-size: 12px !important">
              {{ $utils.meta.format("demand-step-client", row.Step_Client) }}
              <i class="el-icon-arrow-down" />
            </el-link>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-action="'/api/Job/Demand/Progress'"
                @click.native="
                  onProgress({
                    Target: row.Id,
                    Client: row.Client,
                    Address: row.Address,
                    Linkman: row.Linkman,
                    Linktel: row.Linktel,
                    Step_Client: row.Step_Client,
                    Step_Corp: row.Step_Corp,
                  })
                "
              >
                跟进
              </el-dropdown-item>
              <el-dropdown-item
                v-action="'/api/Job/Demand/Submit'"
                @click.native="
                  $router.push({ path: `form`, query: { id: row.Id } })
                "
              >
                修改
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div slot="footer">
      <el-pagination
        background
        :page-size="datalist.PageSize"
        :current-page="datalist.PageIndex"
        :total="datalist.TotalCount"
        @current-change="onSearch"
      />
    </div>
  </full-container>
</template>
  
<script>
import _progress from "./_progress.vue";
import _schdule_detail from "@/views/job/schedule/_detail.vue";
export default {
  components: {
    metaPicker: () => import("@/views/system/meta/item/_picker.vue"),
  },
  data() {
    return {
      loading: false,
      datalist: {},
      queryParams: {
        index: 1,
        size: 20,
        free: false,
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    // 查询参数
    onSearch(val = 1) {
      this.queryParams.index = val;
      this.loadData();
    },
    // 信息列表
    loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.job.demand
        .list(this.queryParams)
        .then((res) => {
          this.datalist = res;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //跟进编辑
    onProgress(row = {}) {
      console.log(row);
      this.$layer.iframe({
        title: "线索跟进",
        area: ["720px", "auto"],
        content: {
          content: _progress,
          parent: this,
          data: {
            source: row,
          },
        },
      });
    },

    //查看跟进内容
    onSchedule(id) {
      this.$layer.iframe({
        title: "跟进工作",
        area: ["600px", "auto"],
        content: {
          content: _schdule_detail,
          parent: this,
          data: {
            id: id,
          },
        },
      });
    },
  },
};
</script>